import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import PageLayout from "../../layouts/PageLayout";
import axios from "axios";
import { BASE_URL, TOKEN, CURRENT_IP } from "../../helper/BASE_URL";
import { ToastContainer, toast } from "react-toastify";

export default function Directs() {
  const [data, setData] = useState([]);

  const { t } = useContext(TranslatorContext);

  useEffect(() => {
    Get_Data();
  }, []);

  const Get_Data = () => {
    const getDta = localStorage.getItem("jwt");
    const parseIT = JSON.parse(getDta);

    try {
      axios
        .post(
          BASE_URL + "get_deposits_log.php",
          {
            userid: parseIT.reg_em,
            token: parseIT.boss_token,
            ip_addr: window.localStorage.getItem('bpipos')?window.localStorage.getItem('bpipos'):'224.234.50.218',
          },
          {
            headers: {
              ClientKey: TOKEN,
            },
          }
        )
        .then((acc) => {
          console.log(acc.data);

          if (acc.data.data.deposits_list[0] !== "NO RECORDS FOUND") {
            setData(acc.data.data.deposits_list);
          }
          
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <PageLayout>
      <ToastContainer/>
      <div className="mc-card">
        <div className="mc-breadcrumb">
          <h3 className="mc-breadcrumb-title">{t("Buy History")}</h3>
          <ul className="mc-breadcrumb-list">
            <li className="mc-breadcrumb-item">
              <Link to="#" className="mc-breadcrumb-link">
                {t("home")}
              </Link>
            </li>
            <li className="mc-breadcrumb-item">{t("Buy History")}</li>
          </ul>
        </div>
      </div>
      <div className="mc-card p-sm-5">
        <table className="mc-table">
          <thead className="mc-table-head">
            <tr>
              <th>S.N.</th>
              <th>Usd amount</th>
              <th>Transaction Id</th>
              <th>Deposit crypto type</th>
              <th>Deposit crypto amount</th>
              <th>Wallet Address</th>

              <th>Received usd</th>
              <th>Status</th>
              <th>Deposit date</th>
            </tr>
          </thead>

          <tbody className="mc-table-body">
            {data.map((hit, index) => {
              return (
                <tr key={index}>
                  <td style={{ width: "5%" }}>{index + 1}</td>
                  <td>{hit.usd_amount}</td>
                  <td>{hit.transaction_id}</td>
                  <td>{hit.deposit_crypto_type}</td>
                  <td>{hit.deposit_crypto_amount}</td>
                  <td>{hit.deposit_wallet_address}</td>
                  <td>{hit.received_usd}</td>
                  <td>{hit.status}</td>
                  <td>{hit.deposit_date}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {
            data.length == 0 &&
            <p style={{textAlign:"center",marginTop:15,fontWeight:"bolder"}}>No Data Found</p>
          }
      </div>
    </PageLayout>
  );
}
